export default __webpack_public_path__ + "static/media/Black-Friday-Web.21a796ed.jpg";